import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';

export const UserCoursesSectionHeader = styled.div`
  align-items: center;
  display: grid;
  gap: 0.625rem;
  grid-template-areas: 'title tooltip filter';
  grid-template-columns: max-content max-content auto;
  margin-bottom: 0.75rem;

  ${media.w.min.px768(css`
    gap: 1.25rem;
  `)};

  ${media.w.min.px992(css`
    grid-template-areas: 'title filter tooltip';
    grid-template-columns: max-content auto max-content;
  `)};
`;
